export default {
  Button: {
    baseStyle: {
      backgroundColor: '#fff',

      _focus: {
        boxShadow: 'none',
      },
    },
    variants: {
      solid({ colorScheme, theme }) {
        if (colorScheme === 'white') {
          return {
            color: '#000',
            backgroundColor: '#fff',
            border: '1px solid #cecece',
            boxShadow: '0px 0px 1px 0px #e7e7e7e6',

            _hover: {
              border: `1px solid ${theme.colors.brand[400]}`,
              color: theme.colors.brand[400],
            },
          };
        }

        return {
          borderColor: 'transparent',
          _hover: {
            bgColor: `${colorScheme}.400`,
            border: '1px solid transparent',
          },
        };
      },
      outline(props) {
        return {
          _hover: {
            bgColor: '#f8f8f8d1',
          },
          _active: {
            bgColor: props?._hover?.bgColor ?? '#f8f8f8d1',
            color:
              props.colorScheme === 'white' ? 'black' : props?._hover?.color ?? props.colorScheme,
          },
        };
      },
      // 初始 style 為 outline，:hover 和 :active 會變為 solid style
      outlineToSolid(props) {
        // 白色沒效果，純粹 chakra ui 的 default outline
        if (props.colorScheme === 'white') {
          return {
            color: 'black',
            _hover: {
              bgColor: '#f8f8f8d1',
            },
            _active: {
              bgColor: '#f8f8f8d1',
            },
          };
        }

        if (props.colorScheme === 'black') {
          return {
            color: 'black',
            bgColor: 'white',
            _hover: {
              bgColor: 'gray.800',
              color: 'white',
            },
            _active: {
              bgColor: 'gray.800',
              color: 'white',
            },
          };
        }

        return {
          color: props.colorScheme ? `${props.colorScheme}.500` : 'brand.500',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: props.colorScheme ? `${props.colorScheme}.500` : 'brand.500',
          _hover: {
            bgColor: props.colorScheme ? `${props.colorScheme}.500` : 'brand.500',
            color: 'white',
          },
          _active: {
            bgColor: `${props.colorScheme}.500` ?? '#f8f8f8d1',
            color: props.colorScheme === 'white' ? 'black' : 'white' ?? props.colorScheme,
          },
        };
      },
    },
  },
};
